import { ReactNode } from 'react';
import { createPortal } from 'react-dom';

interface IMobileAppMenuPortal {
  children: ReactNode;
}

/**
 * Portal component to render mobile app menu at document root level.
 * This ensures position: fixed works correctly without being affected by parent containers.
 */
const MobileAppMenuPortal = ({ children }: IMobileAppMenuPortal) => {
  return createPortal(children, document.body);
};

export default MobileAppMenuPortal;
